import { useOptionsStoreActions } from "@/hooks/store/useOptionsStore";
import { useModal } from "@/components/UI/Modal/useModal";
import { onMounted, ref } from "vue";
import { productionEstimateSettingsApi } from "@/api/production";
import { useProductionStoreActions } from "@/hooks/store/useProductionStore";

export const useProductionEstimateSettings = () => {
  const { loadLasersOptions, lasersOptions } = useOptionsStoreActions();
  const { close } = useModal();
  const { loadProductionEstimate, burnEstimate } = useProductionStoreActions();
  const formData = ref({
    jet: {
      printer_id: null,
      active_printers: null,
    },
    drone: {
      printer_id: null,
      active_printers: null,
    },
    mRocket: {
      printer_id: null,
      active_printers: null,
    },
    rocket: {
      printer_id: null,
      active_printers: null,
    },
  });

  onMounted(() => {
    loadLasersOptions();
    // No config yet (the estimate answers 400) keeps the empty form, so it can be set up.
    const config = burnEstimate?.value?.config ?? {};
    Object.keys(formData.value).forEach((printer) => {
      formData.value[printer] = { ...formData.value[printer], ...config[printer] };
    });
  });
  const handleSubmitAssign = () => {
    productionEstimateSettingsApi(formData.value).then(() => {
      loadProductionEstimate();
      close(null);
    });
  };
  const handleCancel = () => {
    close(null);
  };
  return {
    formData,
    lasersOptions,
    handleSubmitAssign,
    handleCancel,
  };
};
